// @core/api/endpoints/userprofile/list_userprofiles_for_service.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListUserprofilesForServiceResponse,
} from '../../../types/userprofile';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/userprofile';

/**
 * List profiles for user (service method)
 * Returns all profiles belonging to a user account. Intended for internal service use to enumerate user profiles during account operations.
 */
export async function ListUserprofilesForService(
  user_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListUserprofilesForServiceResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/user/:user_id/profiles`;
  requestPath = requestPath.replace(':user_id', encodeURIComponent(user_id));
  const requestOptions = options;
  return client.get<ListUserprofilesForServiceResponse>(requestPath, { ...requestOptions, params });
}
